import { auth } from '@/firebase-config';
import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'map' },
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('@/pages/MapPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      beforeEnter: (_to, _from, next) => {
        if (auth.currentUser && !auth.currentUser.isAnonymous) {
          next({ name: 'home' });
        }
        next();
      },
    },
  ],
});

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !auth.currentUser) {
    return { name: 'login' };
  }
});
